import React from 'react';
import '../css/remixicon/remixicon.css'; 
import 'aos/dist/aos.css'; 

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';


gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const Privacy = () => {

    return(
        <div>
            <section className="page_title policy">
                <div className="page_title_bg policy"></div>
                <div className="page_title_text">
                  <h2>PRIVACY <span style={{ fontWeight: 300 }}>POLICY</span></h2>
                  <p>위즈팩토리 개인정보 취급 방침</p>
                </div>
            </section>
          
            <section className="policy">
                <div className="area">
                  <h2>개인정보 취급 방침</h2>
                  <p>주식회사 위즈팩토리(이하 ＇위즈팩토리＇)는 개인정보보호법에 따라 이용자의 개인정보 및 권익을 보호하고 개인정보와 관련한 이용자의 고충을 원활하게 처리할 수 있도록 다음과 같은 처리방침을 준수하고 있습니다.</p>
                  <p>본 방침은 2024년 8월 27일부터 시행됩니다.</p>
                </div>
            </section>
          
            <section className="policy">
                <div className="area">
                  <h3>1. 개인정보의 수집 목적</h3>
                  <p>위즈팩토리는 다음의 목적을 위하여 개인정보를 수집합니다. 수집하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.</p>
                  <p>1) 문의 업무 처리 : 이용자의 신원 확인, 문의사항 확인, 처리결과 통보 등을 목적으로 개인정보를 수집합니다.</p>
                </div>
            </section>
          
            <section className="policy">
                <div className="area">
                  <h3>2. 개인정보 수집 항목 및 수집 방법</h3>
                  <p>위즈팩토리는 다음의 개인정보 항목을 수집합니다.</p>
                  <p>1) 문의 업무 처리<br />
                    - 수집 항목 : 이름, 회사명, 직급, 연락처, 이메일<br />
                    - 수집 방법 : 홈페이지 문의글 등록 시 수집
                  </p>
                </div>
            </section>
          
            <section className="policy">
                <div className="area">
                  <h3>3. 개인정보의 처리 및 보유기간</h3>
                  <p>위즈팩토리는 개인정보의 수집 및 이용 목적이 달성되거나 이용자의 요청이 있는 경우에는 개인정보를 지체 없이 파기합니다.<br />
                    단, 다음의 개인정보 처리 및 보유기간은 아래와 같습니다.
                  </p>
                  <p>1) 문의 업무 처리 : 분쟁 처리와 관련된 정보는 이용자 동의일로부터 3년<br />
                    - 관련 법령 : 소비자의 불만 또는 분쟁 처리에 관한 기록 3년<br />
                    - 예외 사유 : 관계 법령 위반에 따른 수사·조사 등이 진행중인 경우에는 해당 수사·조사 종료 시까지
                  </p>
                </div>
            </section>
          
            <section className="policy">
                <div className="area">
                  <h3>4. 개인정보의 제3자 제공</h3>
                  <p>위즈코어는 이용자의 개인정보를 ＇1. 개인정보의 수집 목적＇에 명시한 범위 내에서만 처리하며, 원칙적으로 이용자의 동의 없이 개인정보를 외부에 제공하지 않습니다.<br />
                    단, 이용자의 동의 및 법률의 특별한 규정 등 개인정보보호법 제17조, 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.
                  </p>
                  <p>1) 이용자가 개인정보의 제3자 제공에 동의한 경우<br />
                    2) 관련 법령에 의거해 위즈코어에 개인정보 제출 의무가 발생한 경우
                  </p>
                </div>
            </section>
          
            <section className="policy">
                <div className="area">
                  <h3>5. 개인정보의 파기</h3>
                  <p>위즈팩토리는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다. 이용자로부터 동의 받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존해야 하는 경우, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관 장소를 달리하여 보존합니다. 개인정보 파기의 절차 및 방법은 다음과 같습니다.</p>
                  <p>1) 파기절차<br />
                    이용자가 입력한 정보는 목적 달성 후 별도의 DB에 옮겨져 내부 방침 및 기타 관련 법령에 따라 일정기간 저장된 후 혹은 즉시 파기됩니다. 이 때, DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 다른 목적으로 이용되지 않습니다.
                  </p>
                  <p>2) 파기기한<br />
                    이용자의 개인정보 보유기간이 경과된 경우에는 보유기간의 종료일로부터 5일 이내에, 개인정보의 처리 목적 달성, 해당 서비스의 폐지, 사업의 종료 등 그 개인정보가 불필요하게 되었을 경우에는 개인정보의 처리가 불필요한 것으로 인정되는 날로부터 5일 이내에 그 개인정보를 파기합니다.
                  </p>
                  <p>3) 파기방법<br />
                    전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용합니다.
                  </p>
                </div>
            </section>
          
            <section className="policy">
                <div className="area">
                  <h3>6. 이용자와 법정대리인의 권리·의무 및 행사방법</h3>
                  <p>이용자는 개인정보 주체로써 다음과 같은 권리를 행사할 수 있습니다.</p>
                  <p>1) 정보주체는 위즈코어에 언제든지 개인정보 열람, 정정, 삭제, 처리정지 요구 등의 권리를 행사할 수 있습니다.<br />
                    2) 제1항에 따른 권리 행사는 개인정보보호법 시행령 제41조 제1항에 따라 서면, 이메일, 팩스 등을 통하여 하실 수 있으며 위즈코어는 이에 대해 지체 없이 조치하겠습니다.<br />
                    3) 제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 개인정보보호법 시행규칙 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.<br />
                    4) 개인정보 열람 및 처리정지 요구는 개인정보보호법 제35조 제5항, 제37조 제2항에 의하여 정보주체의 권리가 제한될 수 있습니다.<br />
                    5) 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.<br />
                    6) 위즈코어는 정보주체 권리에 따른 열람, 정정, 삭제, 처리정지 요구 시 요구를 한 자가 본인이거나 정당한 대리인인지를 확인합니다.
                  </p>
                </div>
            </section>
          
            <section className="policy">
                <div className="area">
                  <h3>7. 개인정보 자동 수집 장치의 설치·운영 및 거부에 관한 사항</h3>
                  <p>위즈팩토리는 이용자에게 개별적인 맞춤 서비스를 제공하기 위해 이용 정보를 저장하고 수시로 불러오는 ‘쿠키(cookie)’를 사용합니다. 쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며, 이용자의 PC 컴퓨터 내의 하드디스크에 저장되기도 합니다.</p>
                  <p>1) 쿠키의 사용목적 : 이용자의 웹사이트 방문 정보, 검색어 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다.<br />
                    2) 쿠키의 설치∙운영 및 거부 : 웹브라우저 상단의 도구{'>'}인터넷 옵션{'>'}개인정보 메뉴의 옵션 설정을 통해 쿠키 저장을 거부할 수 있습니다.
                  </p>
                </div>
            </section>
          
            <section className="policy">
                <div className="area">
                  <h3>8. 개인정보의 안전성 확보 조치</h3>
                  <p>위즈팩토리는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.</p>
                  <p>1) 관리적 조치 : 내부관리계획 수립 및 시행, 정기적 직원 교육 등<br />
                    2) 기술적 조치 : 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 고유식별정보 등의 암호화, 보안프로그램 설치<br />
                    3) 물리적 조치 : 전산실, 자료보관실 등의 접근 통제
                  </p>
                </div>
            </section>
          
            <section className="policy">
                <div className="area">
                  <h3>9. 개인정보처리방침 변경</h3>
                  <p>이 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경 내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 예정입니다.</p>
                </div>
            </section>
          
            <section className="policy">
                <div className="area">
                  <h3>10. 개인정보보호 책임자</h3>
                  <p>위즈팩토리는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 이용자의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보보호 책임자를 지정하고 있습니다. 위즈팩토리의 웹사이트를 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보보호 책임자에게 문의할 수 있습니다. 위즈팩토리는 정보주체의 문의에 대해 지체 없이 답변 및 처리해드릴 것입니다.</p>
                  <p>개인정보보호 책임자<br />
                    - 성명 : 김민수<br />
                    - 소속 : 위즈팩토리<br />
                    - 직급 : 책임<br />
                    - 전화 : 055-715-7737<br />
                    - 이메일 : wiz_biz@wiz-factory.com
                  </p>
                </div>
            </section>
        </div>
    );
};

export default Privacy;